export class VisualizationLabel {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "BackedByCategory",
            "format": ""
        },
        {
            "name": "label",
            "baseName": "label",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VisualizationLabel.attributeTypeMap;
    }
    constructor() {
    }
}
